import Link from "@/components/link"
import { useUser } from "@clerk/react"

import { Button } from "@anysola/ui/button"
import { ACCOUNT_URL } from "@/lib/app-links"

/**
 * The free plan's button. `/pricing` is static, so whether the visitor has an
 * account is only known after Clerk loads — the same island `SiteHeader` uses.
 * Until then it offers sign-up, which is right for most visitors to this page.
 */
export function FreePlanCta() {
  const { isLoaded, isSignedIn } = useUser()
  const signedIn = isLoaded && isSignedIn

  return (
    <Button
      className="mt-5 w-full md:mt-8"
      size="lg"
      variant="secondary"
      render={<Link href={signedIn ? `${ACCOUNT_URL}/` : "/sign-up"} />}
    >
      {signedIn ? "Go to your dashboard" : "Create an account"}
    </Button>
  )
}
